import { NoCreditChecks } from '../../../images';
import Whi2 from '../../../images/whi-2.png';
import Whi3 from '../../../images/whi-3.png';
import Whi4 from '../../../images/whi-4.png';

/**
 * The Wireless Home Internet trust bar: No Credit Checks / 2-Day Shipping / No Contracts /
 * Simple Self-Install.
 *
 * Shared rather than duplicated because the requirements doc pins this exact set to both
 * states it changes, and it differs from the fiber page's default set (No Forced Bundles /
 * Expert Support / Best Deals & Price). The "No Contracts" item ends in ** and depends on
 * the disclaimerWhi2 footnote being rendered on the same page.
 */
export const getWhiPerkItems = (t) => [
  { title: t('products.perkNoCreditTitle'), desc: t('products.perkNoCreditDesc'), icon: NoCreditChecks },
  { title: t('whi.perkShippingTitle'), desc: t('whi.perkShippingDesc'), icon: Whi2 },
  { title: t('whi.perkNoContractsTitle'), desc: t('whi.perkNoContractsDesc'), icon: Whi3 },
  { title: t('whi.perkSelfInstallTitle'), desc: t('whi.perkSelfInstallDesc'), icon: Whi4 },
];

export default getWhiPerkItems;
